var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4309",
    "data-name": "Group 4309",
    transform: "translate(-555 -447)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 110,
    cy: 110,
    r: 110,
    transform: "translate(555 447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4303",
    "data-name": "Group 4303",
    transform: "translate(-186 -19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M360.811,569.662h64.247a13.915,13.915,0,0,1,13.874,13.874v32.405a13.916,13.916,0,0,1-13.874,13.874H410.083v32.256l-40.994-32.256h-8.278a13.916,13.916,0,0,1-13.874-13.874V583.536a13.915,13.915,0,0,1,13.874-13.874",
    transform: "translate(476.912 -57.314)",
    fill: "#bed2f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M399.559,569.662H356.283a9.373,9.373,0,0,0-9.346,9.345v21.829a9.374,9.374,0,0,0,9.346,9.345H366.37V631.91l27.613-21.728h5.576a9.373,9.373,0,0,0,9.345-9.345V579.007a9.373,9.373,0,0,0-9.345-9.345",
    transform: "translate(433.219 13.539)",
    fill: "#e6edff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1787",
    "data-name": "Rectangle 1787",
    width: 62,
    height: 3,
    rx: 1.5,
    transform: "translate(840 529)",
    fill: "#1169b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    width: 39,
    height: 3,
    rx: 1.5,
    transform: "translate(788 592)",
    fill: "#1169b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1788",
    "data-name": "Rectangle 1788",
    width: 62,
    height: 3,
    rx: 1.5,
    transform: "translate(840 541)",
    fill: "#1169b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 45,
    height: 3,
    rx: 1.5,
    transform: "translate(788 601)",
    fill: "#1169b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    "data-name": "Rectangle 1789",
    width: 26,
    height: 3,
    rx: 1.5,
    transform: "translate(840 553)",
    fill: "#1169b4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    width: 26,
    height: 3,
    rx: 1.5,
    transform: "translate(788 610)",
    fill: "#1169b4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyComments);
export default __webpack_public_path__ + "static/media/empty-comments.c5114e82b89ffb25d56a9c351de5a57e.svg";
export { ForwardRef as ReactComponent };